import { signInCreateNewAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInCreateNewAccount";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

signInCreateNewAccountStyles.createNewAccountButton!.variant = "primary";
signInCreateNewAccountStyles.checkoutAsGuestButton! = {
    variant: "secondary",
    css: css`
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                null,
                null,
                css`
                    margin-bottom: 1rem;
                `,
            ],
            "max",
        )}
    `,
};